import { render, staticRenderFns } from "./CreateCarouselButton.vue?vue&type=template&id=296cdd9a&scoped=true&"
import script from "./CreateCarouselButton.vue?vue&type=script&lang=js&"
export * from "./CreateCarouselButton.vue?vue&type=script&lang=js&"
import style0 from "./CreateCarouselButton.vue?vue&type=style&index=0&id=296cdd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cdd9a",
  null
  
)

export default component.exports